import React from 'react';

import cn from 'classnames';
import useTranslation from 'hooks/useTranslation';

import s from './WalletConfirm.module.scss';

// Presentational status pill. No wallet/web3 code — safe to render anywhere
// (dashboard card AND read-only profile) without the WalletConnect provider.
const WalletStatusBadge = ({ isConfirmed }) => {
  const t = useTranslation();
  return (
    <span className={cn(s.badge, isConfirmed ? s.badgeOk : s.badgeWarn)}>
      <span className={s.badgeDot} />
      {isConfirmed ? t('wallet_confirm_badge_confirmed') : t('wallet_confirm_badge_unconfirmed')}
    </span>
  );
};

export default WalletStatusBadge;
